import { CSSObject } from '@mui/material';

import { darken } from 'color2k';

import { primary, grey, red, yellow, blue, green } from '../../options/palette';

const hue = 500;

const hover = 0.1;
const active = 0.15;

const contained: CSSObject = {
  // Color Styling
  containedPrimary: {
    'background': primary,
    'backgroundColor': primary,
    'borderColor': primary,
    'color': '#FFF',

    '&.MuiLoadingButton-loading': {
      background: primary,
      backgroundColor: primary,
      borderColor: primary,
      color: '#FFF'
    },

    '&:hover': {
      background: darken(primary, hover),
      backgroundColor: darken(primary, hover),
      borderColor: darken(primary, hover),
      color: '#FFF'
    },

    '&:active': {
      background: darken(primary, active),
      backgroundColor: darken(primary, active),
      borderColor: darken(primary, active),
      color: '#FFF'
    }
  },
  containedSecondary: {
    'background': grey[hue],
    'backgroundColor': grey[hue],
    'borderColor': grey[hue],
    'color': '#FFF',

    '&.MuiLoadingButton-loading': {
      background: grey[hue],
      backgroundColor: grey[hue],
      borderColor: grey[hue],
      color: '#FFF'
    },

    '&:hover': {
      background: darken(grey[hue], hover),
      backgroundColor: darken(grey[hue], hover),
      borderColor: darken(grey[hue], hover),
      color: '#FFF'
    },

    '&:active': {
      background: darken(grey[hue], active),
      backgroundColor: darken(grey[hue], active),
      borderColor: darken(grey[hue], active),
      color: '#FFF'
    }
  },
  containedSuccess: {
    'background': green[hue],
    'backgroundColor': green[hue],
    'borderColor': green[hue],
    'color': '#FFF',

    '&.MuiLoadingButton-loading': {
      background: green[hue],
      backgroundColor: green[hue],
      borderColor: green[hue],
      color: '#FFF'
    },

    '&:hover': {
      background: darken(green[hue], hover),
      backgroundColor: darken(green[hue], hover),
      borderColor: darken(green[hue], hover),
      color: '#FFF'
    },

    '&:active': {
      background: darken(green[hue], active),
      backgroundColor: darken(green[hue], active),
      borderColor: darken(green[hue], active),
      color: '#FFF'
    }
  },
  containedError: {
    'background': red[hue],
    'backgroundColor': red[hue],
    'borderColor': red[hue],
    'color': '#FFF',

    '&.MuiLoadingButton-loading': {
      background: red[hue],
      backgroundColor: red[hue],
      borderColor: red[hue],
      color: '#FFF'
    },

    '&:hover': {
      background: darken(red[hue], hover),
      backgroundColor: darken(red[hue], hover),
      borderColor: darken(red[hue], hover),
      color: '#FFF'
    },

    '&:active': {
      background: darken(red[hue], active),
      backgroundColor: darken(red[hue], active),
      borderColor: darken(red[hue], active),
      color: '#FFF'
    }
  },
  containedInfo: {
    'background': blue[hue],
    'backgroundColor': blue[hue],
    'borderColor': blue[hue],
    'color': '#FFF',

    '&.MuiLoadingButton-loading': {
      background: blue[hue],
      backgroundColor: blue[hue],
      borderColor: blue[hue],
      color: '#FFF'
    },

    '&:hover': {
      background: darken(blue[hue], hover),
      backgroundColor: darken(blue[hue], hover),
      borderColor: darken(blue[hue], hover),
      color: '#FFF'
    },

    '&:active': {
      background: darken(blue[hue], active),
      backgroundColor: darken(blue[hue], active),
      borderColor: darken(blue[hue], active),
      color: '#FFF'
    }
  },
  containedWarning: {
    'background': yellow[hue],
    'backgroundColor': yellow[hue],
    'borderColor': yellow[hue],
    'color': '#FFF',

    '&.MuiLoadingButton-loading': {
      background: yellow[hue],
      backgroundColor: yellow[hue],
      borderColor: yellow[hue],
      color: '#FFF'
    },

    '&:hover': {
      background: darken(yellow[hue], hover),
      backgroundColor: darken(yellow[hue], hover),
      borderColor: darken(yellow[hue], hover),
      color: '#FFF'
    },

    '&:active': {
      background: darken(yellow[hue], active),
      backgroundColor: darken(yellow[hue], active),
      borderColor: darken(yellow[hue], active),
      color: '#FFF'
    }
  },

  // Sizes Styling
  containedSizeSmall: {
    'borderWidth': '1px',

    '&:hover': {
      borderWidth: '1px'
    },

    '&:active': {
      borderWidth: '1px'
    },

    '&.Mui-disabled': {
      'borderWidth': '1px',

      '&:hover': {
        borderWidth: '1px'
      },

      '&:active': {
        borderWidth: '1px'
      }
    }
  },
  containedSizeMedium: {
    'borderWidth': '2px',

    '&:hover': {
      borderWidth: '2px'
    },

    '&:active': {
      borderWidth: '2px'
    },

    '&.Mui-disabled': {
      'borderWidth': '2px',

      '&:hover': {
        borderWidth: '2px'
      },

      '&:active': {
        borderWidth: '2px'
      }
    }
  },
  containedSizeLarge: {
    'borderWidth': '2px',

    '&:hover': {
      borderWidth: '2px'
    },

    '&:active': {
      borderWidth: '2px'
    },

    '&.Mui-disabled': {
      'borderWidth': '2px',

      '&:hover': {
        borderWidth: '2px'
      },

      '&:active': {
        borderWidth: '2px'
      }
    }
  }
};

export default contained;
